import React from 'react';
import { Mail } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Mail",
    title: "Professional Email",
    description: "Your @yourdomain.fr address"
  },
  {
    iconName: "HardDrive",
    title: "50 GB Storage",
    description: "Generous storage space"
  },
  {
    iconName: "Shield",
    title: "Advanced Protection",
    description: "Anti-spam and anti-virus included"
  },
  {
    iconName: "Smartphone",
    title: "Multi-Device",
    description: "Full synchronization"
  },
  {
    iconName: "Calendar",
    title: "Integrated Calendar",
    description: "Collaborative calendar"
  },
  {
    iconName: "Users",
    title: "Contacts",
    description: "Advanced contact management"
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or certificate of enrollment"
  },
  {
    title: "Activate your email",
    description: "Receive your credentials via email within 24 hours"
  }
];

const MailPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.europeanstudent.org/store/messagerie';
  };
  return (
    <div>
      <ServiceHeader
        title="Professional Email"
        description="A complete and secure email solution for your professional communications."
        icon={<Mail className="w-8 h-8 text-white" />}
        color={colors.primary}
        imageUrl="https://images.unsplash.com/photo-1557200134-90327ee9fafa?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.primary}
            />
          ))}
        </div>

        {/* Detailed Features */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Included Features</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Professional Email</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Custom email address</li>
                  <li>• IMAP/POP3/SMTP protocols</li>
                  <li>• Responsive webmail</li>
                  <li>• Custom signatures</li>
                  <li>• Automatic replies</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Security and Protection</h3>
                <ul className="space-y-3 text-gray-600">
                  <li>• Advanced anti-spam</li>
                  <li>• Integrated anti-virus</li>
                  <li>• SSL/TLS encryption</li>
                  <li>• Daily backups</li>
                  <li>• Phishing protection</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="pt-11">
          <ServiceSteps
                title="How to Benefit"
                steps={steps}
                color={colors.primary}
                ctaText="Activate my email"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default MailPage;